<template>
    <svg width="22" height="11" viewBox="0 0 22 11" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M22 11L10.5 0L0 11H22Z" fill="#F3F9FF" />
    </svg>
</template>